import { render, staticRenderFns } from "./ApeironOrganizationsDetail.vue?vue&type=template&id=0c3a47a7"
import script from "./ApeironOrganizationsDetail.vue?vue&type=script&lang=js"
export * from "./ApeironOrganizationsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports